export default {
    getAllSDM17SPGs: () => {
        return {
            url: '/fhepool/SDM17SPGs',
            method: 'GET'
        };
    },
    getSDM17SPGDetails: SDM17SPGId => {
        return {
            url: '/fhepool/SDM17SPGs/:SDM17SPGId',
            method: 'GET',
            route_params: {
                SDM17SPGId
            }
        };
    }
};



// WEBPACK FOOTER //
// ./environments/fhepool/data/SDM17SPG/api.js